module.exports = __webpack_public_path__ + "img/icon_sm_fscpck.2e4ef393.png";